'use client';

import { atomWithStorage } from '@capsicum/common';

export const setDeliveryCountryAtom = atomWithStorage<string | undefined>('deliveryCountry', '');
